import React from 'react'

export interface StandardLoaderProps {
  /** Text to display below the spinner */
  text?: string
  /** Size of the spinner - affects both width/height and border thickness */
  size?: 'sm' | 'md' | 'lg'
  /** Whether to center the loader in a full-screen container */
  fullScreen?: boolean
  /** Additional CSS classes */
  className?: string
  inline?: boolean
}

const sizeConfig = {
  sm: 'h-4 w-4 border-2 border-transparent border-t-accent',
  md: 'h-6 w-6 border-2 border-transparent border-t-accent',
  lg: 'h-8 w-8 border-2 border-transparent border-t-accent'
}

export const StandardLoader: React.FC<StandardLoaderProps> = ({
  text,
  size = 'lg',
  fullScreen = false,
  className = '',
  inline = false
}) => {
  const content = (
    <div className={`flex flex-col items-center space-y-4 ${className} ${inline ? 'mx-2' : ''}`}>
      <div className={`animate-spin rounded-full ${sizeConfig[size]}`}></div>
      {text && (
        <p className="text-muted-foreground text-sm">{text}</p>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        {content}
      </div>
    )
  }

  return content
}
